import { transformQueryData } from "./utils";

const queryActionReducer = (state: any, payload: any) => {
  const actionType = payload.action;

  switch (actionType) {
    case "TRANSFORM_RESPONSE": {
      const {
        overallQueryItemMapByTableName,
        response,
        setSelectedTableNames,
      } = payload;

      if (response?.queries && response.queries.length < 1) return state;
    
      const { selected_tables, table_data_map_by_id } = transformQueryData(
        response,
        overallQueryItemMapByTableName
      );
      if (setSelectedTableNames) setSelectedTableNames(selected_tables);
      return table_data_map_by_id;
    }
    case "ON_TABLE_CHANGE": {
      const { tableName, isSelected } = payload;

      if (!isSelected) {
        const nextState = { ...state };
        delete nextState[tableName];

        return nextState;
      }

      const nextItem = {
        tableName,
        columns: [],
        isAllColumnsSelected: false,
      };

      // nextItem.columns = overallColumns.columns;
      nextItem.columns = [];
      nextItem.isAllColumnsSelected = true;

      return {
        ...state,
        [tableName]: nextItem,
      };
    }
    case "ON_COLUMN_CHANGE": {
      const {
        columnName,
        tableName,
        isChecked,
        setSelectedTableNames,
        overAllColumns,
      } = payload;

      const tableItem = { ...(state?.[tableName] || {}) };
      const nextColumns = isChecked
        ? [...(tableItem?.columns || []), columnName]
        : tableItem?.columns.filter((col: string) => col !== columnName);

      // Update the selectedTableNames if needed
      const hasSelectedColumns = nextColumns.length > 0;

      setSelectedTableNames((current: string[]) => {
        if (hasSelectedColumns && !current.includes(tableName)) {
          return [...current, tableName];
        }
        //  else if (!hasSelectedColumns) {
        //   return current.filter((name) => name !== tableName);
        // }
        return current;
      });

      const isNoColumnsSelected = nextColumns.length === 0;
      // if (isNoColumnsSelected) {
      //   const nextState = { ...state };
      //   delete nextState[tableName];
      //   return nextState;
      // }
      
      
      const isAllColumnsSelected = isNoColumnsSelected || overAllColumns.columns.length === nextColumns.length;
      
      return {
        ...state,
        [tableName]: {
          ...tableItem,
          tableName,
          columns: nextColumns,
          isAllColumnsSelected,
        },
      };
    }
    case 'RESET': {
      const {setSelectedTableNames} = payload
      setSelectedTableNames([])
      return {}
    }
    case "SELECT_ALL_TABLES": {
      const { overallQueryItemMapByTableName, setSelectedTableNames } = payload;
      const nextState = { ...state };
      Object.keys(overallQueryItemMapByTableName).forEach((tableName) => {
        // const tableItem = overallQueryItemMapByTableName[tableName];
        nextState[tableName] = {
          tableName,
          columns: [],
          isAllColumnsSelected: true,
        };
      });
      setSelectedTableNames(Object.keys(overallQueryItemMapByTableName));
      return nextState;
    }

    default:
      return state;
  }
};

export default queryActionReducer;
